module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul>\r\n  <li class="percrit_save ui-menu-item">\r\n    <a href="javascript:void(0)" class="percrit_save">\r\n      '+
((__t=(i18n.t('agenda.percrit_save')))==null?'':__t)+
'\r\n    </a>\r\n  </li>\r\n  <li class="percrit_suppr ui-menu-item">\r\n    <a href="javascript:void(0)" class="percrit_suppr">\r\n      '+
((__t=(i18n.t('agenda.percrit_suppr')))==null?'':__t)+
'\r\n    </a>\r\n  </li>\r\n</ul>\r\n';
}
return __p;
};
